// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-UR1","icon":"styles_icon__9LHTD"};